import React, { Fragment } from "react";
import dislike_png from "../../../assets/media/articles/dislike.png";
import like_png from "../../../assets/media/articles/like.png";
import thinking_png from "../../../assets/media/articles/thinking.png";
const AgreeablenessInput = ({ content, setSelectedOption }) => {
  return (
    <Fragment>
      <p className="agreeableness">{content}</p>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "30%",
          }}
        >
          <img src={like_png} width="40" alt="like" />
          <div
            style={{
              backgroundColor: "#D5FFC6",
              fontSize: 12,
              textAlign: "center",
              padding: 9,
              width: "100%",
              marginTop: 10,
            }}
          >
            I agree
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "30%",
          }}
        >
          <img src={thinking_png} width="40" alt="thinking" />
          <div
            style={{
              backgroundColor: "#FFDE7A",
              fontSize: 12,
              textAlign: "center",
              padding: 9,
              width: "100%",
              marginTop: 10,
            }}
          >
            I'm sitting on the fence
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "30%",
          }}
        >
          <img src={dislike_png} width="40" alt="disagree" />
          <div
            style={{
              backgroundColor: "#FFA8A7",
              fontSize: 12,
              textAlign: "center",
              padding: 9,
              width: "100%",
              marginTop: 10,
            }}
          >
            I disagree
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AgreeablenessInput;



// WEBPACK FOOTER //
// ./src/screens/Articles/components/AgreeablenessInput.js